// extracted by mini-css-extract-plugin
export default {"overlay":"GlobalSpinner_overlay__kRmU6"};